/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _region = _interopRequireDefault(require("../region"));
_region.default.prototype.alignToRegion = function (region, alignPositions) {
  _region.default.align(this, region, alignPositions);
  return this;
};
_region.default.prototype.alignToPoint = function (point, anchor) {
  _region.default.alignToPoint(this, point, anchor);
  return this;
};


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/region-align/Region.proto.js
// module id = 767
// module chunks = 0